var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "新建简历",
      "visible": _vm.showDialog,
      "close-on-click-modal": false,
      "close-on-press-escape": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.ruleForm,
      "label-width": "100px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gender", $$v)
      },
      expression: "ruleForm.gender"
    }
  }, _vm._l((_vm.selectMap.WB_GENDER), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "mobilePhone"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.mobilePhone),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "mobilePhone", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.mobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.email"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最高学历",
      "prop": "maxDegree"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.maxDegree),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxDegree", $$v)
      },
      expression: "ruleForm.maxDegree"
    }
  }, _vm._l((_vm.selectMap.WB_EDU_DEGREE), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应聘城市:",
      "prop": "expectCityId"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.expectCityId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "expectCityId", $$v)
      },
      expression: "ruleForm.expectCityId"
    }
  }, _vm._l((_vm.selectMap.WB_POSITION_CITY), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "最高学校",
      "prop": "maxSchool"
    }
  }, [_c('el-autocomplete', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "size": "medium",
      "fetch-suggestions": _vm.remoteMethod,
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.maxSchool),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxSchool", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.maxSchool"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "专业",
      "prop": "maxMajor"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.maxMajor),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "maxMajor", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "ruleForm.maxMajor"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    staticClass: "width-longer",
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "label": "就读时间:",
      "prop": "attendTimes"
    }
  }, [_c('el-date-picker', {
    ref: "startDate",
    attrs: {
      "type": "month",
      "placeholder": "开始时间",
      "size": "medium",
      "picker-options": _vm.startDateOption
    },
    on: {
      "change": _vm.startDateChange
    },
    model: {
      value: (_vm.ruleForm.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "beginTime", $$v)
      },
      expression: "ruleForm.beginTime"
    }
  }), _vm._v("\n                至\n                "), _c('el-date-picker', {
    ref: "endDate",
    attrs: {
      "type": "month",
      "placeholder": "结束时间",
      "size": "medium",
      "picker-options": _vm.endDateOption
    },
    on: {
      "change": _vm.endDateChange
    },
    model: {
      value: (_vm.ruleForm.endTime),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "endTime", $$v)
      },
      expression: "ruleForm.endTime"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "简历来源",
      "prop": "resumeSource"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.resumeSource),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "resumeSource", $$v)
      },
      expression: "ruleForm.resumeSource"
    }
  }, _vm._l((_vm.selectMap.WB_RESUME_SOURCE), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "接受调剂:",
      "prop": "acceptRegulate"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.ruleForm.acceptRegulate),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "acceptRegulate", $$v)
      },
      expression: "ruleForm.acceptRegulate"
    }
  }, _vm._l((_vm.selectMap.WB_ACCEPT_REGULATE), function(item, index) {
    return _c('el-radio', {
      key: item.value,
      attrs: {
        "label": item.value
      }
    }, [_vm._v("\n                            " + _vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘职位",
      "prop": "positionId"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "medium",
      "filterable": "",
      "remote": "",
      "placeholder": "请输入关键词",
      "clearable": true,
      "remote-method": _vm.positionIdRemoteMethod
    },
    model: {
      value: (_vm.ruleForm.positionId),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "positionId", $$v)
      },
      expression: "ruleForm.positionId"
    }
  }, _vm._l((_vm.positionList), function(item, index) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "游戏经验",
      "prop": "gameExperience"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "resize": "none",
      "maxlength": 1000
    },
    model: {
      value: (_vm.ruleForm.gameExperience),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "gameExperience", $$v)
      },
      expression: "ruleForm.gameExperience"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "当前所在地",
      "prop": "residence"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "medium",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.residence),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "residence", $$v)
      },
      expression: "ruleForm.residence"
    }
  })], 1), _vm._v(" "), _c('attach-view', {
    ref: "attach",
    attrs: {
      "data": [],
      "rid": "",
      "init": _vm.cacheData,
      "action": ((_vm.$axios.defaults.baseURL) + "/resumeAttach/resumefileInsertNew.api")
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并添加下一位")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13f1a478"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/addResumeDialog.vue
// module id = null
// module chunks = 